import script from "./[report].vue?vue&type=script&setup=true&lang=ts"
export * from "./[report].vue?vue&type=script&setup=true&lang=ts"

import "./[report].vue?vue&type=style&index=0&id=2b0eeb2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b0eeb2a"]])

export default __exports__